define.alias("shared/components/shared/ui/navigation-arrows", "media/components/shared/ui/navigation-arrows");